import * as React from 'react';
import { Form, Text, Select, Checkbox, TextArea } from 'react-form';
import { SingleDatePicker } from 'react-dates';
import { api } from '@src/services/api';
import { _ } from "@src/services/i18n";
import { Switch } from '@src/services/form';
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoEdit, PropsEdit, StateEdit } from '@src/components/Proto';
import { Box, Modal } from '@src/components';

// typing
interface LocalProps extends PropsEdit {
}
interface LocalState extends StateEdit {
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Department extends ProtoEdit<LocalProps, LocalState> {

	// render
	render() {
        const loading = this.loading();
        if (loading) return null;
        const { id, onCancel } = this.props;
        const { data, values = {}, entity = null, error } = this.state;
        if (entity === null) return null;

        const customers = data.customers.map( v => ({ value: v.id, label: v.name }));
        
        return (
            <Modal
                title={!id ? _('new_title', 'SettingsDepartment') : _('edit_title', 'SettingsDepartment', { name: entity.description } ) }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.save(v)}
                        defaultValues={ entity.customer ? { custid: entity.customer.id, ...entity } : null }
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="custid">{_(`field_custid`, 'SettingsDepartment')}</label>
                                    <Select field="custid" id="custid" options={customers} className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="description">{_('field_description', 'SettingsDepartment')}</label>
                                    <Text field="description" id="description" className="form-control" />
                                </article>
                            </div>
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                {_(`btn_cancel`, 'Settings')}
                                </button>
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_save`, 'Settings')} 
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/Department.tsx